import React from 'react'
import classnames from 'classnames'
import Badge, { BadgeProps } from 'components/Badge/Badge'

import styles from './BadgeList.module.css'

export type BadgeListProps = {
  name?: string | undefined
  prefix?: string | undefined
  options: string[] | null | undefined
  onDismissClick?: (option: string, index: number) => void
} & Omit<BadgeProps, 'children' | 'onDismissClick'>

const BadgeList = ({ className, color, style, prefix, options, onDismissClick, ...props }: BadgeListProps) => {
  return (
    <div className={classnames(styles.badgeListContainer, className)}>
      {options?.map((option, index) => (
        <Badge
          key={index}
          color={color}
          style={style}
          onDismissClick={onDismissClick ? () => onDismissClick(option, index) : undefined}
          {...props}>
          {prefix ? `${prefix}: ${option}` : option}
        </Badge>
      ))}
    </div>
  )
}

export default BadgeList
